import { UserModel } from './UserModel';
import { PlanMemberModel } from './PlanMemberModel';

export class MemberModel {
    constructor(memberData) {
        const user = this.getUser(memberData);
        const planMembers = this.getPlanMembers(memberData);

        this._member = {
            id: memberData.id,
            credits: memberData.credits,
            status: memberData.status,
            createdAt: memberData.createdAt,
            user,
            planMembers,
        };
    }

    get member() {
        return this._member;
    }

    getUser(memberData) {
        let user;

        if (memberData.user) {
            const userModel = new UserModel(memberData.user.data);
            user = { ...userModel._user };
        }

        return user;
    }

    getPlanMembers(memberData) {
        let planMembers = [];

        if (memberData.plan_members) {
            planMembers = memberData.plan_members.data.map(planMember => {
                const planMemberModel = new PlanMemberModel(planMember);
                return { ...planMemberModel._planMember };
            });
        }

        return planMembers;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/MemberModel.js